module.exports = __webpack_public_path__ + "img/108.0b1815b2.jpg";